export default "__VITE_ASSET__DQL9LPmq__"